const NAVIGATION_SEPARATOR = '|';

export default NAVIGATION_SEPARATOR;
